const RESOURCES = [
    {
        name: "Minerals",
        path: "icon-mineral-nobg.png",
    },
    {
        name: "Vespene",
        path: "icon-gas-protoss-nobg.png",
    },
    {
        name: "SupplyTerran",
        path: "btn-building-terran-supplydepot.png",
    },
    {
        name: "SupplyProtoss",
        path: "btn-building-protoss-pylon.png",
    },
    {
        name: "SupplyZerg",
        path: "btn-unit-zerg-overlord.png",
    },
    {
        name: "Larva",
        path: "btn-unit-zerg-larva.png",
    },
    {
        name: "MULE",
        path: "btn-unit-terran-mule.png",
    },
]
export default RESOURCES
